import i18n from "~/i18n";

export const LOCALES = i18n.supportedLngs;

type Locale = (typeof LOCALES)[number];

export default Locale;
